import * as React from "react";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";

export default function WebhooksTable() {
  const [webhooks, setWebhooks] = React.useState([]);
  const [err, setErr] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 60,
    },
    {
      field: "wh_type",
      headerName: "wh_type",
      minWidth: 150,
      flex: 1 ,
    },
    {
      field: "wh_id",
      headerName: "wh_id",
      minWidth: 150,
      flex: 1 ,
    },
    {
      field: "cust_id",
      headerName: "cust_id",
      minWidth: 150,
      flex: 1 ,
    },
    {
      field: "data",
      headerName: "data",
      minWidth: 150,
      flex: 2, 
    },
    {
      field: "timestamp",
      headerName: "timestamp",
      minWidth: 150,
      flex: 2 ,
    },
  ];

  React.useEffect(() => {
    axios
      .get(`/web_hooks`)
      .then((res) => {
        setWebhooks(res.data.webhooks);
        setIsLoading(false);
      })
      .catch((err) => {
        setErr(err.message);
      });
  }, []);

  return (
    <React.Fragment>
      {err ? (
        <p>{err}</p>
      ) : (
        <div
          id="m"
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            alignItems: "flex-end",
          }}
        >
          <Box sx={{ height: 660, width: "100%" }}>
            <DataGrid
              loading={isLoading}
              getRowHeight={() => "auto"}
              // getRowId={(row) => row.internalId}
              rows={webhooks}
              columns={columns}
              pageSize={10}
              
              rowsPerPageOptions={[10]}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              initialState={{
                sorting: {
                  sortModel: [{ field: "id", sort: "desc" }],
                },
              }}
            />
          </Box>
        </div>
      )}
    </React.Fragment>
  );
}
